import { render, staticRenderFns } from "./section-contacto-principal.vue?vue&type=template&id=2d6dc7c2&scoped=true"
import script from "./section-contacto-principal.vue?vue&type=script&lang=js"
export * from "./section-contacto-principal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6dc7c2",
  null
  
)

export default component.exports